import $ from "jquery"
import "nodelist-foreach-polyfill"
import "regenerator-runtime/runtime"
import { loadGoogleMaps, mapStyles } from "./../utils"

const CLASSNAME = {
	activeLocation: "map-location--active",
}

let headerStyleEl = document.head.appendChild(document.createElement("style"))

const infoWindowTemplate = ({ featureImage, url, title, address }) => `
    <div class="info-window__container">
        <div class="info-window__content">
            <div class="info-window__title">${title}</div>
            <!--div class="info-window__item">${address}</div-->
        </div>
    </div>
`

const locationCSSTemplates = ({ handle, markerColour }) => `
    .gm-style .gm-style-iw-t.info-window--${handle} .gm-style-iw-c {border-top: 5px solid ${markerColour};}
`

const smoothZoom = (map, max, cnt) => {
	if (cnt >= max) return
	let z = google.maps.event.addListener(map, "zoom_changed", () => {
		google.maps.event.removeListener(z)
		smoothZoom(map, max, cnt + 1)
	})
	setTimeout(function() {
		map.setZoom(cnt)
	}, 80) // 80ms is what I found to work well on my system -- it might not work well on all systems
}

const mapMarkerSvg = ({ type, colour }) => {
	let path = "",
		scaledSize = { w: 32, h: 32 },
		labelOrigin = { x: 16, y: 10 },
		scale = 1

	switch (type) {
		case "small":
			;(scaledSize = { w: 32, h: 32 }), (labelOrigin = { x: 16, y: 10 })
			path = `M16,16a5,5,0,1,1,5-5,5,5,0,0,1-4.91,5ZM16,0A11,11,0,0,0,5,10.93V11c0,6.1,11,21,11,21S27,17.1,27,11A11,11,0,0,0,16.09,0Z`
			scale = 1

			break

		case "flat":
			;(scaledSize = { w: 33, h: 48 }), (labelOrigin = { x: 11, y: 12 })
			path = `M11,0C4.9,0,0,4.9,0,10.9c0,0,0,0,0,0.1c0,6.1,11,21,11,21s11-14.9,11-21C22,4.9,17.1,0,11,0C11,0,11,0,11,0z`
			scale = 1.25

			break
	}

	return {
		size: new google.maps.Size(scaledSize.w, scaledSize.h),
		origin: new google.maps.Point(0, 0),
		scaledSize: new google.maps.Size(scaledSize.w, scaledSize.h),
		labelOrigin: new google.maps.Point(labelOrigin.x, labelOrigin.y),
		optimized: false,
		zIndex: 1,
		scale: scale,
		path: path,
		fillColor: colour,
		fillOpacity: 1,
		strokeColor: colour,
		strokeWeight: 0,
	}
}

const setBoundriesNew = (
	map,
	markersArray,
	setBounds = true,
	markerClusterer = null
) => {
	if (markersArray.length === 0) return

	const bounds = new google.maps.LatLngBounds()

	if (setBounds) {
		for (var i = 0; i < markersArray.length; i++) {
			if (markersArray[i].lat < 0 && markersArray[i].lng > 0) {
				bounds.extend(markersArray[i].getPosition())
			}
		}
	}

	if (markerClusterer) {
		//clear marker clusterer
		markerClusterer.clearMarkers()

		//reset marker clusterer with new markers
		markerClusterer.addMarkers(markersArray)
	}

	if (setBounds) {
		map.fitBounds(bounds)
	}
}

const createSidebar = (
	map,
	markers,
	showSidebar,
	sidebarEl,
	addressEl,
	suburbsDropdown,
	markerClusterer,
	global
) => {
	// const   times = [];

	$.each(markers, function(index, location) {
		headerStyleEl.append(
			locationCSSTemplates({
				handle: location.handle,
				markerColour: location.markerColour,
			})
		)
	})

	sidebarEl.on("click", "[data-map-location]", function() {
		// Get list of locations for this map
		$(sidebarEl)
			.find("[data-map-location]")
			.removeClass(CLASSNAME.activeLocation)

		// Add the active class to the selected sidebar location
		$("#" + $(this).attr("id")).addClass(CLASSNAME.activeLocation)

		// Trigger a click on the marker
		google.maps.event.trigger(
			markers[
				$(this)
					.attr("id")
					.split("-")[1] - 1
			],
			"click"
		)
	})
}

const createMarkers = ({ map, locations, showSidebar, uid }) => {
	// This function picks up the click and opens the corresponding info window

	const markers = []

	let currentInfoWindow = null

	$.each(locations, function(index, location) {
		let activity = location.title,
			time = location.time,
			summary = location.summary,
			gallery = location.gellery,
			locationTitle = location.locationTitle,
			locationFeatureImage = location.locationFeatureImage,
			locationTownship = location.locationTownship,
			locationSummary = location.locationSummary,
			locationLinkId = `${uid}location-${index + 1}`,
			locationAddress = location.locationAddress,
			locationWebsite = location.locationWebsite,
			locationEmail = location.locationEmail,
			locationPhone = location.locationPhone,
			locationSocialMedia = location.locationSocialMedia,
			locationOpeningHours = location.locationOpeningHours,
			locationLat = location.locationLat,
			locationLng = location.locationLng,
			locationMarkerColour = location.locationMarkerColour

		const markerImageOptions = {
				small: mapMarkerSvg({
					type: "small",
					colour: locationMarkerColour,
				}),
				flat: mapMarkerSvg({
					type: "flat",
					colour: locationMarkerColour,
				}),
			},
			labelOptions = {
				text: `${index + 1}`,
				color: "white",
				fontSize: "12px",
				fontFamily: "Imprima, lato, bree, sans-serif",
			}

		const latInt = parseFloat(locationLat),
			longInt = parseFloat(locationLng),
			latLng = new google.maps.LatLng(latInt, longInt)

		const marker = new google.maps.Marker({
			map: map,
			position: latLng,
			lat: latInt,
			lng: longInt,
			id: locationLinkId,
			animation: google.maps.Animation.DROP,
			icon: showSidebar
				? markerImageOptions.flat
				: markerImageOptions.small, // Default icon
			title: activity,
			locationName: locationTitle,
			time: time,
			suburb: locationTownship,
			summary: summary,
			locationSummary: locationSummary,
			markerColour: locationMarkerColour,
			gallery: gallery,
			featureImage: locationFeatureImage,
			address: locationAddress,
			url: locationWebsite,
			email: locationEmail,
			socialMedia: locationSocialMedia,
			phone: locationPhone,
			openingHours: locationOpeningHours,
			label: showSidebar ? labelOptions : null,
		})

		const infowindow = new google.maps.InfoWindow({
			content: infoWindowTemplate({
				featureImage: locationFeatureImage,
				url: locationWebsite,
				title: locationTitle,
				address: locationAddress,
			}),
		})

		marker.addListener("click", function(e) {
			// Close other previously opened infowindow
			if (currentInfoWindow != null) {
				currentInfoWindow.close()
			}

			$("[data-map-location]").removeClass(CLASSNAME.activeLocation)

			map.panTo(latLng)
			smoothZoom(map, 20, map.getZoom())

			if (showSidebar) {
				var target = document.getElementById(locationLinkId)
				target.classList.add(CLASSNAME.activeLocation)
				target.parentNode.scrollTop = target.offsetTop
			}

			infowindow.open(map, marker)
			currentInfoWindow = infowindow
		})

		google.maps.event.addListener(infowindow, "domready", function() {
			const iwOuter = $(".gm-style-iw"),
				iwBackground = iwOuter.prev()

			iwOuter.parent().addClass("info-window")
			iwBackground
				.children(
					":nth-child(1), :nth-child(2), :nth-child(3), :nth-child(4)"
				)
				.css({ display: "none" })
		})

		google.maps.event.addListener(infowindow, "closeclick", function() {
			const closeEls = document.getElementById("close-locations"),
				detailListEl = document.querySelector(
					"[data-map-sidebar-details]"
				)

			$("[data-map-location]").removeClass(CLASSNAME.activeLocation)
			closeEls.classList.remove("is-active")
			detailListEl.classList.remove("is-active")
			if (showSidebar) {
				setBoundriesNew(map, markers, true)
			}
		})

		markers.push(marker)
	})

	return markers
}

const init = (
	mapInstance,
	{ mapLocations, mapSidebar, mapZoom, mapSuburb },
	uid,
	global
) => {
	let lat = mapSuburb.lat != "" ? mapSuburb.lat : -34.691669,
		lng = mapSuburb.lng != "" ? mapSuburb.lng : 138.666855,
		latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
		northEast = new google.maps.LatLng(-34.615447, 138.846904),
		southWest = new google.maps.LatLng(-34.779413, 138.435675),
		playfordBounds = new google.maps.LatLngBounds(southWest, northEast),
		zoom = mapZoom != "" ? Number(mapZoom) : 14

	const locations = mapLocations,
		showSidebar = mapSidebar,
		styles = mapStyles

	const map = new google.maps.Map(mapInstance, {
		center: latLng,
		zoom: zoom,
		styles: styles,
		streetViewControl: false,
		overviewMapControl: false,
		mapTypeControl: false,
		scaleControl: false,
		bounds: playfordBounds,
		strictBounds: true,
		componentRestrictions: { country: "au" },
	})

	const sidebarEl = $(mapInstance)
		.parent()
		.find("[data-map-sidebar]")

	const addressEl = document.getElementById(`${uid}Input`),
		suburbsDropdown = $(`#${uid}Suburb`),
		trigerEls = document.querySelectorAll("[data-map-location-trigger]"),
		detailEls = document.querySelectorAll("[data-map-location-detail]"),
		detailListEl = document.querySelector("[data-map-sidebar-details]"),
		closeEls = document.getElementById("close-locations")

	const markers = createMarkers({
		map,
		locations,
		showSidebar,
		uid,
	})

	if (trigerEls) {
		trigerEls.forEach(function(el) {
			el.addEventListener(
				"click",
				e => {
					e.preventDefault()

					const triggerTargetName = el.dataset.mapLocationTrigger
					const triggerTargetEl = document.querySelector(
						`#${triggerTargetName}`
					)
					const headerEl = document.querySelector(`[data-day-header]`)

					triggerTargetEl.classList.toggle("is-active")
					detailListEl.classList.add("is-active")
					closeEls.classList.toggle("is-active")
				},
				true
			)
		})
	}

	if (closeEls) {
		closeEls.addEventListener(
			"click",
			e => {
				closeEls.classList.toggle("is-active")
				detailListEl.classList.remove("is-active")
				detailEls.forEach(function(el) {
					el.classList.remove("is-active")
				})
			},
			true
		)
	}

	setBoundriesNew(map, markers, true)

	// Creating side bar and toggle
	createSidebar(
		map,
		markers,
		showSidebar,
		sidebarEl,
		addressEl,
		suburbsDropdown,
		global
	)
}

class TabbedMap {
	constructor(element) {
		const uid = element.getAttribute("data-map-interactive")
		if (!uid in window) return

		this.map = element
		init(this.map, window[uid], uid, this)
	}
}

const loadMap = async () => {
	const tabMapElements = document.querySelectorAll("[data-map-interactive]")

	if (tabMapElements.length === 0) return

	// Wait for the map libraries to load
	await loadGoogleMaps()

	// Create tab maps for each map on the page
	tabMapElements.forEach(element => new TabbedMap(element))
}

export { loadMap }
